// extracted by mini-css-extract-plugin
export var gif = "_i4-0";